const HASANTA = '্';

const WORD_MAP = {
    nirdisto: 'নির্দিষ্ট',
    nirdishto: 'নির্দিষ্ট',
    onek: 'অনেক',
    ekhon: 'এখন',
    khub: 'খুব',
    valo: 'ভালো',
    bhalo: 'ভালো',
    ami: 'আমি',
    tumi: 'তুমি',
    she: 'সে',
    kemon: 'কেমন',
    acho: 'আছো',
    achho: 'আছো',
    achi: 'আছি',
    achhi: 'আছি',
    ar: 'আর',
    ebong: 'এবং',
    theke: 'থেকে',
    amader: 'আমাদের',
    tomader: 'তোমাদের',
    tader: 'তাদের',
    shobar: 'সবার',
    shobai: 'সবাই',
    onno: 'অন্য',
    obostha: 'অবস্থা',
    sonar: 'সোনার',
    bangla: 'বাংলা',
    ki: 'কি',
    kintu: 'কিন্তু',
    ho: 'হও',
    hoye: 'হয়ে',
    holo: 'হলো',
    hobe: 'হবে',
    noyon: 'নয়ন',
    kre: 'করে',
    kore: 'করে',
    dekhechi: 'দেখেছি',
    dekhechhi: 'দেখেছি',
    dekheche: 'দেখেছে',
    dekhechhe: 'দেখেছে',
    ghrane: 'ঘ্রাণে',
    pagl: 'পাগল',
    vora: 'ভরা',
    bhore: 'ভরে',
    khete: 'ক্ষেতে',
    modhur: 'মধুর',
    bodon: 'বদন',
    molin: 'মলিন',
    hle: 'হলে',
    jole: 'জলে',
    vasi: 'ভাসি',
    bhasi: 'ভাসি',
    akash: 'আকাশ',
    batas: 'বাতাস',
    prane: 'প্রাণে',
    bajay: 'বাজায়',
    bashi: 'বাঁশি',
    ma: 'মা',
    oma: 'ওমা',
    fagune: 'ফাল্গুনে',
    tor: 'তোর',
    amer: 'আমের',
    bne: 'বনে',
    oghrane: 'অঘ্রাণে',
};

const PATTERNS = [
    ['ksh', 'ক্ষ', 'C'], ['chh', 'ছ', 'C'], ['GY', 'জ্ঞ', 'C'], ['gy', 'জ্ঞ', 'C'],
    ['kh', 'খ', 'C'], ['gh', 'ঘ', 'C'], ['Ng', 'ঙ', 'C'],
    ['Ch', 'ছ', 'C'], ['ch', 'চ', 'C'], ['jh', 'ঝ', 'C'],
    ['Th', 'ঠ', 'C'], ['Dh', 'ঢ', 'C'], ['th', 'থ', 'C'],
    ['dh', 'ধ', 'C'], ['ph', 'ফ', 'C'], ['bh', 'ভ', 'C'],
    ['Sh', 'ষ', 'C'], ['sh', 'শ', 'C'], ['rr', 'ড়', 'C'],
    ['Rr', 'ঢ়', 'C'], ['ng', 'ং', 'S'], ['ny', 'ঞ', 'C'],
    ['aa', 'আ', 'V'], ['ii', 'ঈ', 'V'], ['uu', 'ঊ', 'V'],
    ['ee', 'ই', 'V'], ['oi', 'ঐ', 'V'], ['ou', 'ঔ', 'V'],
    ['OI', 'ঐ', 'V'], ['OU', 'ঔ', 'V'],
    ['ndh', 'ন্ধ', 'C'], ['nth', 'ন্থ', 'C'], ['ghr', 'ঘ্র', 'C'],
    ['nd', 'ন্দ', 'C'], ['nt', 'ন্ত', 'C'],
    ['sht', 'ষ্ট', 'C'],
    ['ShT', 'ষ্ট', 'C'],
    ['rd', 'র্দ', 'C'],
    ['st', 'স্ত', 'C'],
    ['sk', 'স্ক', 'C'], ['mp', 'ম্প', 'C'], ['mb', 'ম্ব', 'C'], ['nk', 'ঙ্ক', 'C'],
    ['ng', 'ঙ্গ', 'C'], ['nj', 'ঞ্জ', 'C'], ['sn', 'স্ন', 'C'],
    ['sp', 'স্প', 'C'], ['pt', 'প্ত', 'C'], ['bd', 'ব্ধ', 'C'],
    ['gd', 'গ্ধ', 'C'], ['kt', 'ক্ত', 'C'], ['tt', 'ত্ত', 'C'],
    ['kk', 'ক্ক', 'C'], ['ll', 'ল্ল', 'C'], ['mm', 'ম্ম', 'C'],
    ['nn', 'ন্ন', 'C'], ['tr', 'ত্র', 'C'], ['pr', 'প্র', 'C'],
    ['kr', 'ক্র', 'C'], ['gr', 'গ্র', 'C'], ['br', 'ব্র', 'C'],
    ['dr', 'দ্র', 'C'], ['shr', 'শ্র', 'C'], ['str', 'স্ত্র', 'C'],
    ['mpr', 'ম্প্র', 'C'], ['spr', 'স্প্র', 'C'],
    ['chhi', 'ছি', 'V_M'], ['chhe', 'ছে', 'V_M'],
    ['chi', 'চি', 'V_M'], ['che', 'চে', 'V_M'],
    ['T', 'ট', 'C'], ['D', 'ড', 'C'], ['N', 'ণ', 'C'],
    ['R', 'ড়', 'C'], ['S', 'শ', 'C'],
    ['k', 'ক', 'C'], ['g', 'গ', 'C'], ['c', 'চ', 'C'],
    ['j', 'জ', 'C'], ['t', 'ত', 'C'], ['d', 'দ', 'C'],
    ['n', 'ন', 'C'], ['p', 'প', 'C'], ['f', 'ফ', 'C'],
    ['b', 'ব', 'C'], ['v', 'ভ', 'C'], ['m', 'ম', 'C'],
    ['z', 'য', 'C'], ['r', 'র', 'C'], ['l', 'ল', 'C'],
    ['s', 'স', 'C'], ['h', 'হ', 'C'], ['y', 'য়', 'C'],
    ['x', 'ক্স', 'C'], ['q', 'ক', 'C'], ['w', 'ও', 'V'],
    ['a', 'আ', 'V'], ['A', 'আ', 'V'], ['i', 'ই', 'V'],
    ['I', 'ঈ', 'V'], ['u', 'উ', 'V'], ['U', 'ঊ', 'V'],
    ['e', 'এ', 'V'], ['E', 'এ', 'V'],
    ['o', 'অ', 'V_O'],
    ['O', 'ও', 'V'],
];

const PATTERNS_LONGEST_FIRST = PATTERNS.map((row, idx) => ({ row, idx }))
    .sort((A, B) => {
        const d = B.row[0].length - A.row[0].length;
        if (d !== 0) return d;
        return A.idx - B.idx;
    })
    .map(({ row }) => row);

const MATRA = {
    আ: 'া',
    ই: 'ি',
    ঈ: 'ী',
    উ: 'ু',
    ঊ: 'ূ',
    ঋ: 'ৃ',
    এ: 'ে',
    ঐ: 'ৈ',
    ও: 'ো',
    ঔ: 'ৌ',
};
const O_MATRA = MATRA['ও'];

const BN_CONS = {
    ক: 'k', খ: 'kh', গ: 'g', ঘ: 'gh', ঙ: 'ng',
    চ: 'ch', ছ: 'chh', জ: 'j', ঝ: 'jh', ঞ: 'ny',
    ট: 'T', ঠ: 'Th', ড: 'D', ঢ: 'Dh', ণ: 'N',
    ত: 't', থ: 'th', দ: 'd', ধ: 'dh', ন: 'n',
    প: 'p', ফ: 'ph', ব: 'b', ভ: 'bh', ম: 'm',
    য: 'z', র: 'r', ল: 'l', শ: 'sh', ষ: 'Sh',
    স: 's', হ: 'h', 'ড়': 'rr', 'ঢ়': 'Rr', 'য়': 'y',
    'ৎ': 't',
};
const BN_VOWELS = {
    অ: 'o', আ: 'a', ই: 'i', ঈ: 'ii', উ: 'u',
    ঊ: 'uu', ঋ: 'ri', এ: 'e', ঐ: 'oi', ও: 'o', ঔ: 'ou',
};
const BN_MATRAS = {
    '\u09be': 'a',
    '\u09bf': 'i',
    '\u09c0': 'ii',
    '\u09c1': 'u',
    '\u09c2': 'uu',
    '\u09c3': 'ri',
    '\u09c7': 'e',
    '\u09c8': 'oi',
    '\u09cb': 'o',
    '\u09cc': 'ou',
};
const BN_SYMBOLS = { 'ং': 'ng', 'ঃ': 'H', 'ঁ': '~~' };
const BN_MULTI = {
    ক্ষ: 'ksh',
    জ্ঞ: 'gy',
    শ্র: 'shr',
    ষ্ট: 'sht',
    র্দ: 'rd',
};
const BN_RANGE = /[\u0980-\u09FF]/;

export const REFERENCE_ROWS = [
    ['ksh', 'ক্ষ'], ['GY / gy', 'জ্ঞ'],
    ['tr', 'ত্র'], ['dr', 'দ্র'], ['pr', 'প্র'], ['br', 'ব্র'],
    ['gr', 'গ্র'], ['kr', 'ক্র'], ['shr', 'শ্র'], ['str', 'স্ত্র'],
    ['st', 'স্ত'], ['sht / ShT', 'ষ্ট'], ['rd', 'র্দ'],
    ['sp', 'স্প'], ['sk', 'স্ক'], ['sn', 'স্ন'],
    ['nd', 'ন্দ'], ['mb', 'ম্ব'], ['nj', 'ন্জ'], ['nk', 'ন্ক'],
    ['tt', 'ত্ত'], ['nn', 'ন্ন'], ['ll', 'ল্ল'], ['mm', 'ম্ম'],
    ['k', 'ক'], ['kh', 'খ'], ['g', 'গ'], ['gh', 'ঘ'],
    ['ch', 'চ'], ['chh', 'ছ'], ['j', 'জ'], ['jh', 'ঝ'],
    ['T', 'ট'], ['Th', 'ঠ'], ['D', 'ড'], ['Dh', 'ঢ'],
    ['t', 'ত'], ['th', 'থ'], ['d', 'দ'], ['dh', 'ধ'],
    ['n', 'ন'], ['N', 'ণ'], ['p', 'প'], ['ph/f', 'ফ'],
    ['b', 'ব'], ['bh/v', 'ভ'], ['m', 'ম'], ['r', 'র'],
    ['rr', 'ড়'], ['l', 'ল'], ['sh/S', 'শ'], ['Sh', 'ষ'],
    ['s', 'স'], ['h', 'হ'], ['y', 'য়'], ['z', 'য'],
    ['ng', 'ং'], ['a', 'আ'], ['i', 'ই'], ['u', 'উ'],
    ['e', 'এ'], ['o', 'অ'], ['O', 'ও'], ['oi', 'ঐ'], ['ou', 'ঔ'],
];

export function banglishToBangla(input) {
    if (!input) return '';

    const tokens = input.split(/([a-zA-Z]+)/);
    let finalResult = '';

    for (const token of tokens) {
        if (!token) continue;
        if (!/[a-zA-Z]/.test(token)) {
            finalResult += token;
            continue;
        }

        const lowToken = token.toLowerCase();
        if (WORD_MAP[lowToken]) {
            finalResult += WORD_MAP[lowToken];
            continue;
        }

        let result = '';
        let i = 0;
        let prevType = 'S';

        while (i < token.length) {
            let matched = false;
            for (const [pat, bn, type] of PATTERNS_LONGEST_FIRST) {
                if (token.substr(i, pat.length) === pat) {
                    if (type === 'V_O') {
                        result += prevType === 'C' ? O_MATRA : bn;
                        prevType = 'V';
                    } else if (type === 'V') {
                        const matra = MATRA[bn];
                        result += (prevType === 'C' && matra) ? matra : bn;
                        prevType = 'V';
                    } else if (type === 'C') {
                        result += bn;
                        prevType = 'C';
                    } else {
                        result += bn;
                        prevType = 'S';
                    }
                    i += pat.length;
                    matched = true;
                    break;
                }
            }

            if (!matched) {
                result += token[i];
                prevType = 'S';
                i += 1;
            }
        }
        finalResult += result;
    }

    return finalResult;
}

export function banglaToBanglish(input) {
    let result = '';
    let i = 0;

    while (i < input.length) {
        const ch = input[i];

        const tri = input.substr(i, 3);
        if (BN_MULTI[tri]) {
            result += BN_MULTI[tri];
            const after = input[i + 3];
            if (after && BN_MATRAS[after]) {
                result += BN_MATRAS[after];
                i += 4;
            } else {
                i += 3;
            }
            continue;
        }

        const latinCons = BN_CONS[ch];
        if (latinCons) {
            result += latinCons;
            const next = input[i + 1];
            if (next === HASANTA) {
                i += 2;
            } else if (next && BN_MATRAS[next]) {
                result += BN_MATRAS[next];
                i += 2;
            } else if (!next || !BN_RANGE.test(next)) {
                i += 1;
            } else if (BN_CONS[next] || BN_SYMBOLS[next]) {
                result += 'o';
                i += 1;
            } else {
                i += 1;
            }
            continue;
        }

        const latinVowel = BN_VOWELS[ch];
        if (latinVowel) {
            result += latinVowel;
            i += 1;
            continue;
        }

        const latinSym = BN_SYMBOLS[ch];
        if (latinSym) {
            result += latinSym;
            i += 1;
            continue;
        }

        if (BN_MATRAS[ch]) {
            result += BN_MATRAS[ch];
            i += 1;
            continue;
        }

        result += ch;
        i += 1;
    }

    return result;
}

export function convertBanglishText(input, mode) {
    if (!input) return '';
    return mode === 'banglishToBangla'
        ? banglishToBangla(input)
        : banglaToBanglish(input);
}
